import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Checkbox from "./Checkbox";
import AllergyModal from "./AllergyModal";
import CareTeamModal from "./CareTeamModal";
import ClientRateModal from "./ClientRateModal";
import CareModalityModal from "./CareModalityModal";
import ClientPayorModal from "./ClientPayorModal";
import AddressModal from "./AddressModal";
import DiagnosisModal from "./DiagnosisModal";
import BedSearchModal from "./BedSearchModal";
import BedAppointmentModal from "./BedAppointmentModal";
import MedicationModal from "./MedicationModal";
import DemographicsModal from "./DemographicsModal";
import { getFieldName } from "../../scripts/helperScripts";

function UpdateRecordsModal({
  clientId,
  clientProgram,
  forceOpen,
  forceClose,
  fosterHomePrograms,
  updateAddresses,
  updateAllergies,
  updateClientPayors,
  modalities,
  updateModalities,
  updateRates,
  updateCareTeam,
  updateMedications,
  updateDiagnosis,
  updateBeds,
  updateBedAppointments,
  existingCareTeam,
  addresses,
  isLoading,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [activeModal, setActiveModal] = useState("");
  const [activeIndex, setActiveIndex] = useState(0);
  const [selectedModals, setSelectedModals] = useState([]);
  const [data, setData] = useState({ all: false });
  const [addressBeingCreated, setAddressBeingCreated] = useState(false);

  useEffect(() => {
    setIsOpen(forceOpen);
  }, [forceOpen]);

  const showModal = () => {
    setIsOpen(true);
    setAddressBeingCreated(false);
  };

  const handleHideModal = () => {
    if (forceClose) forceClose();
    setIsOpen(false);
  };

  const handleChange = ({ currentTarget: input }) => {
    const obj = { ...data };
    obj[input.name] = input.checked;

    if (!input.checked) {
      obj.all = false;
    }

    if (input.name === "all") {
      obj.demographics = input.checked;
      obj.careTeam = input.checked;
      obj.diagnosis = input.checked;
      obj.careModality = input.checked;
      obj.clientRate = input.checked;
      obj.addresses = input.checked;
      obj.clientPayor = input.checked;
      obj.allergies = input.checked;
      obj.bedSearch = input.checked;
      obj.bedAppointment = input.checked;
      obj.medications = input.checked;
    }

    setData(obj);
  };

  const launchModals = () => {
    setActiveIndex(0);
    const modals = [];
    if (data.all || data.demographics) modals.push("demographics");

    if (data.all || data.careTeam) modals.push("careTeam");

    if (data.all || data.diagnosis) modals.push("diagnosis");

    if (data.all || data.careModality) modals.push("careModality");

    if (data.all || data.addresses) modals.push("addresses");

    if (data.all || data.clientPayor) modals.push("clientPayor");

    if (data.all || data.allergies) modals.push("allergies");

    if (data.all || data.bedSearch) modals.push("bedSearch");

    if (data.all || data.bedAppointment) modals.push("bedAppointment");

    if (data.all || data.medications) modals.push("medications");

    setSelectedModals(modals);
    setIsOpen(false);
    setActiveModal(modals[0]);
  };

  const handleNextModal = () => {
    if (activeIndex + 1 < selectedModals.length) {
      setActiveModal(selectedModals[activeIndex + 1]);
      setActiveIndex(activeIndex + 1);
    } else {
      console.log("HandleNextModalFinished");
      setActiveIndex(0);
      setActiveModal("");
      setSelectedModals([]);
      setData({});
      if (forceClose) forceClose();
    }
  };

  const handleUpdateAddresses = (doUpdate) => {
    setAddressBeingCreated(false);

    updateAddresses && updateAddresses(doUpdate);
  };

  return (
    <>
      {forceOpen === undefined && (
        <button className="btn btn-primary border" onClick={showModal}>
          Update Client Records
        </button>
      )}
      {isOpen ? (
        <Modal show={isOpen} animation={false}>
          <Modal.Header>
            <Modal.Title>Update Client Records</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {isLoading && <>Loading...</>}
            {!isLoading && (
              <>
                Select Record Types to Update:
                <div className="m-3">
                  <Checkbox
                    name="all"
                    label="Select All"
                    checked={data.all}
                    onChange={handleChange}
                  />
                  <Checkbox
                    name="demographics"
                    label="Demographics"
                    checked={data.demographics}
                    onChange={handleChange}
                  />
                  <Checkbox
                    name="careTeam"
                    label="Care Team"
                    checked={data.careTeam}
                    onChange={handleChange}
                  />
                  <Checkbox
                    name="diagnosis"
                    label="Diagnosis"
                    checked={data.diagnosis}
                    onChange={handleChange}
                  />
                  <Checkbox
                    name="careModality"
                    label="Client Rate/Care Modality"
                    checked={data.careModality}
                    onChange={handleChange}
                  />
                  <Checkbox
                    name="addresses"
                    label="Addresses"
                    checked={data.addresses}
                    onChange={handleChange}
                  />
                  <Checkbox
                    name="clientPayor"
                    label="Client Payor"
                    checked={data.clientPayor}
                    onChange={handleChange}
                  />
                  <Checkbox
                    name="allergies"
                    label="Allergies"
                    checked={data.allergies}
                    onChange={handleChange}
                  />
                  <Checkbox
                    name="bedSearch"
                    label="Bed Search"
                    checked={data.bedSearch}
                    onChange={handleChange}
                  />
                  <Checkbox
                    name="bedAppointment"
                    label="Bed Appointment"
                    checked={data.bedAppointment}
                    onChange={handleChange}
                  />
                  <Checkbox
                    name="medications"
                    label="Medications"
                    checked={data.medications}
                    onChange={handleChange}
                    disabled={clientProgram["con.birthdate"] === undefined}
                    title={
                      clientProgram["con.birthdate"] === undefined
                        ? "Missing DOB for patient"
                        : null
                    }
                  />
                </div>
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-danger" onClick={handleHideModal}>
              Cancel
            </button>
            <button className="btn btn-primary" onClick={launchModals}>
              Start
            </button>
          </Modal.Footer>
        </Modal>
      ) : null}
      {activeModal === "demographics" ? (
        <DemographicsModal
          isOpen={activeModal === "demographics"}
          nextModal={handleNextModal}
          isLastModal={activeIndex === selectedModals.length - 1}
          clientId={clientId}
        ></DemographicsModal>
      ) : null}
      {activeModal === "addresses" ? (
        <AddressModal
          isOpen={activeModal === "addresses"}
          nextModal={handleNextModal}
          isLastModal={activeIndex === selectedModals.length - 1}
          clientId={clientId}
          clientProgram={clientProgram}
          updateAddresses={handleUpdateAddresses}
          setAddressBeingCreated={setAddressBeingCreated}
        ></AddressModal>
      ) : null}
      {activeModal === "allergies" ? (
        <AllergyModal
          isOpen={activeModal === "allergies"}
          nextModal={handleNextModal}
          isLastModal={activeIndex === selectedModals.length - 1}
          clientId={clientId}
          clientProgram={clientProgram}
          updateAllergies={updateAllergies}
        ></AllergyModal>
      ) : null}
      {activeModal === "careTeam" ? (
        <CareTeamModal
          isOpen={activeModal === "careTeam"}
          nextModal={handleNextModal}
          isLastModal={activeIndex === selectedModals.length - 1}
          clientProgram={clientProgram}
          updateCareTeam={updateCareTeam}
          existingCareTeam={existingCareTeam}
        ></CareTeamModal>
      ) : null}
      {clientProgram &&
      getFieldName(clientProgram.ccx_company) !== "SAFY of Alabama" ? (
        <>
          {activeModal === "careModality" ? (
            <ClientRateModal
              isOpen={activeModal === "careModality"}
              nextModal={handleNextModal}
              isLastModal={activeIndex === selectedModals.length - 1}
              clientId={clientId}
              clientProgram={clientProgram}
              fosterHomePrograms={fosterHomePrograms}
              modalities={modalities}
              updateModalities={updateModalities}
              updateRates={updateRates}
            ></ClientRateModal>
          ) : null}
        </>
      ) : null}
      {clientProgram &&
      getFieldName(clientProgram.ccx_company) === "SAFY of Alabama" ? (
        <>
          {activeModal === "careModality" ? (
            <CareModalityModal
              isOpen={activeModal === "careModality"}
              nextModal={handleNextModal}
              isLastModal={activeIndex === selectedModals.length - 1}
              clientId={clientId}
              clientProgram={clientProgram}
              fosterHomePrograms={fosterHomePrograms}
              modalities={modalities}
              updateModalities={updateModalities}
            ></CareModalityModal>
          ) : null}
        </>
      ) : null}
      {activeModal === "clientPayor" ? (
        <ClientPayorModal
          isOpen={activeModal === "clientPayor"}
          nextModal={handleNextModal}
          isLastModal={activeIndex === selectedModals.length - 1}
          clientId={clientId}
          clientProgram={clientProgram}
          updateClientPayors={updateClientPayors}
          updateAddresses={updateAddresses}
          addresses={addresses}
          careTeam={existingCareTeam}
          addressBeingCreated={addressBeingCreated}
        ></ClientPayorModal>
      ) : null}
      {activeModal === "diagnosis" ? (
        <DiagnosisModal
          isOpen={activeModal === "diagnosis"}
          nextModal={handleNextModal}
          isLastModal={activeIndex === selectedModals.length - 1}
          clientId={clientId}
          clientProgram={clientProgram}
          updateDiagnosis={updateDiagnosis}
        ></DiagnosisModal>
      ) : null}
      {activeModal === "bedSearch" ? (
        <BedSearchModal
          isOpen={activeModal === "bedSearch"}
          nextModal={handleNextModal}
          isLastModal={activeIndex === selectedModals.length - 1}
          clientId={clientId}
          clientProgram={clientProgram}
          updateBeds={updateBeds}
        ></BedSearchModal>
      ) : null}
      {activeModal === "bedAppointment" ? (
        <BedAppointmentModal
          isOpen={activeModal === "bedAppointment"}
          nextModal={handleNextModal}
          isLastModal={activeIndex === selectedModals.length - 1}
          clientProgram={clientProgram}
          updateBedAppointments={updateBedAppointments}
        ></BedAppointmentModal>
      ) : null}
      {activeModal === "medications" ? (
        <MedicationModal
          isOpen={activeModal === "medications"}
          nextModal={handleNextModal}
          isLastModal={activeIndex === selectedModals.length - 1}
          clientId={clientId}
          clientProgram={clientProgram}
          updateMedications={updateMedications}
        ></MedicationModal>
      ) : null}
    </>
  );
}

export default UpdateRecordsModal;
